module.exports = __webpack_public_path__ + "img/ad.93eb3ad0.png";